
<div class="filters-row" style="display: flex;  gap: 16px">
  <div class="filter-container">
    <label class="filter-label">{{ formatLabel(data?.name) }}</label>
    <ng-select class="global-dropdown-select" [class.is-open]="isDropdownOpen" [appendTo]="appendTarget" [items]="filteredOptions" [multiple]="data?.isMultiSelect" [closeOnSelect]="false" [hideSelected]="false" [(ngModel)]="selected"
      [searchable]="false" [clearable]="data?.clearable !== false && !data?.disabled" [disabled]="data?.disabled === true" [placeholder]="placeholderText" (ngModelChange)="onChange($event)" (open)="onDropdownOpen()" (close)="onDropdownClose()">
      <ng-template ng-header-tmp>
        <div class="custom-header">
          <!-- Search input -->
          <div class="search-wrapper">
            <!-- <mat-icon class="search-icon" fontIcon="search"></mat-icon> -->
            <input type="text" class="search-input" placeholder="Search" [formControl]="searchCtrl" (keydown)="$event.stopPropagation()"/>
          </div>


        <div class="custom-option" *ngIf="data?.isMultiSelect">
          <input type="checkbox" id="select-all" [checked]="isAllSelected" (change)="toggleSelectAll($event)" />
          <label for="select-all">&nbsp;Select All</label>
        </div>
      </div>
    </ng-template>

    <ng-template ng-option-tmp let-item="item" let-index="index">
      <div [title]="formatOption(item)" (click)="onItemClick(item)">
        <input id="item-{{ index }}" type="checkbox" [checked]="isItemSelected(item)" [matTooltip]="formatOption(item)"
          matTooltipPosition="right" />
        {{ formatOption(item) }}
      </div>
    </ng-template>

    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
      <span
        *ngIf="usePlainTextLabel; else chipMultiLabel"
        class="plain-multi-label"
        [title]="plainSelectionText(items)"
      >
        <span class="plain-multi-values" *ngIf="visiblePlainSelectionCount > 0">
          {{ visiblePlainSelectionText(items) }}
        </span>
        <span class="tag-summary" *ngIf="hiddenPlainSelectionCount(items) > 0">
          +{{ hiddenPlainSelectionCount(items) }} more
        </span>
      </span>

      <ng-template #chipMultiLabel>
        <div class="custom-multi-label-wrapper">
          <ng-container *ngIf="items?.length > 0">
            <div class="ng-value">
              <span class="ng-value-icon left" (click)="clear(items[0])">×</span>
              <span class="ng-value-label">
                {{ formatOption(items[0]) }}
              </span>
            </div>
          </ng-container>
          <span class="tag-summary" *ngIf="items?.length > 1">
            +{{ items.length - 1 }} more
          </span>
        </div>
      </ng-template>
    </ng-template>

  </ng-select>
</div>
